import { render } from "./BodyPallete.vue?vue&type=template&id=8dc2939e&scoped=true"
import script from "./BodyPallete.vue?vue&type=script&lang=js"
export * from "./BodyPallete.vue?vue&type=script&lang=js"

import "./BodyPallete.vue?vue&type=style&index=0&id=8dc2939e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dc2939e"]])

export default __exports__